const BUILD_ID = __BUILD_ID__;
const BUILD_ID_KEY = "app_build_id";

async function clearBrowserCaches(): Promise<void> {
    if ("caches" in window) {
        const cacheKeys = await caches.keys();
        await Promise.all(cacheKeys.map((key) => caches.delete(key)));
    }

    if ("serviceWorker" in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map((reg) => reg.unregister()));
    }
}

export async function ensureFreshClient(): Promise<void> {
    try {
        const previousBuildId = localStorage.getItem(BUILD_ID_KEY);

        if (previousBuildId && previousBuildId !== BUILD_ID) {
            localStorage.setItem(BUILD_ID_KEY, BUILD_ID);
            sessionStorage.clear();
            await clearBrowserCaches();
            window.location.reload();
            return;
        }

        if (!previousBuildId) {
            localStorage.setItem(BUILD_ID_KEY, BUILD_ID);
        }
    } catch {
        // Fail-safe: never block app startup
    }
}